import { UpdateOwnerDto, WorkOrderCostApprovalEnum } from '@inosio/payments-sdk';
import { Typography, Radio, FormControl, FormControlLabel, RadioGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import { useState } from 'react';
import NumberFormat from 'react-number-format';
import { useDispatch } from 'react-redux';
import { getUpdatingOwner, selectOwnerDetails } from '../sagas/ownersSlice';
import { useSelector } from 'react-redux';

const inputRootStyle = {
  width: '100px',
  height: '27px',
  textAlign: 'center' as 'center',
  borderRadius: '24px',
  border: '1px solid #F1F0F5',
  padding: '0 8px',
  outline: 'none !important',
};

const useStyles = makeStyles(() => ({
  labelText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '25px !important',
    color: '#14142B',
  },
  inputRoot: {
    ...inputRootStyle,
    '&:hover': {
      borderColor: 'rgb(0, 0, 0, 0.87)',
    },
    '&:focus': {
      borderColor: 'rgb(25, 118, 210)',
    },
  },
}));

export interface OwnerDetailsMaintenanceProps {
  ownerUuid: string;
}

export function OwnerDetailsMaintenance(props: OwnerDetailsMaintenanceProps) {
  const OwnerDetails = useSelector(selectOwnerDetails);
  const [costLimitValue, setCostLimitValue] = useState<number | null | undefined>(OwnerDetails.CostLimit);
  const [costApproval, setCostApproval] = useState<WorkOrderCostApprovalEnum | null | undefined>(OwnerDetails.WorkOrderCostApproval);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleCostApprovalChange = (costApproval: WorkOrderCostApprovalEnum) => {
    dispatch({
      type: getUpdatingOwner.type,
      payload: {
        ownerUuid: props.ownerUuid,
        updateOwnerDto: {
          WorkOrderCostApproval: costApproval,
        } as UpdateOwnerDto,
      },
    });
  };

  const handleBlurCostLimit = () => {
    if (costLimitValue !== null) {
      dispatch({
        type: getUpdatingOwner.type,
        payload: {
          ownerUuid: props.ownerUuid,
          updateOwnerDto: {
            CostLimit: costLimitValue,
          } as UpdateOwnerDto,
        },
      });
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          p: 1,
          borderBottom: '1px solid #EEEEEE',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography sx={{ ml: 2, color: '#14142B' }} className={classes.labelText}>
          {`Maintenance`}
        </Typography>
      </Box>

      <Box sx={{ ml: 3, mt: 2, display: 'flex' }}>
        <Typography sx={{ color: '#14142B', fontFamily: 'Work Sans', mr: 2 }}>Cost limit:</Typography>
        <NumberFormat
          onValueChange={(values) => {
            setCostLimitValue(values.floatValue != null ? values.floatValue * 100 : null);
          }}
          value={costLimitValue == null ? null : costLimitValue / 100}
          thousandSeparator
          isNumericString
          fixedDecimalScale
          decimalScale={2}
          prefix="$"
          className={classes.inputRoot}
          placeholder="$0.00"
          onBlur={handleBlurCostLimit}
        />
      </Box>

      <Box sx={{ ml: 3, mt: 4 }}>
        <Typography sx={{ color: '#14142B', fontFamily: 'Work Sans', mb: 2 }}>Call for Approval:</Typography>
        <FormControl component="fieldset">
          <RadioGroup
            value={costApproval ?? ''}
            onChange={(event) => {
              setCostApproval(event.target.value as WorkOrderCostApprovalEnum);
              handleCostApprovalChange(event.target.value as WorkOrderCostApprovalEnum);
            }}
          >
            <FormControlLabel
              value={WorkOrderCostApprovalEnum.AboveLimit}
              control={<Radio />}
              label={<Typography sx={{ color: '#14142B', fontFamily: 'Work Sans', fontSize: '16px', fontWeight: 500 }}>Above this limit</Typography>}
            />
            <FormControlLabel
              value={WorkOrderCostApprovalEnum.Always}
              control={<Radio />}
              label={<Typography sx={{ color: '#14142B', fontFamily: 'Work Sans', fontSize: '16px', fontWeight: 500 }}>Always Call</Typography>}
            />
            <FormControlLabel
              value={WorkOrderCostApprovalEnum.Never}
              control={<Radio />}
              label={<Typography sx={{ color: '#14142B', fontFamily: 'Work Sans', fontSize: '16px', fontWeight: 500 }}>Never Call</Typography>}
            />
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
}
